import React from "react";
import "./terms-conditions.css";

const TermsConditions = () => {
  return (
    <div className="tc-container">
      <header className="tc-header mb-3">
        <h1>Terms & Conditions</h1>
      </header>

      <section className="tc-content mb-3">
        <p>
          These terms of use (hereinafter the "Terms & Conditions") establish a legally binding agreement between 
          <b> MARATHON FINLEASE PRIVATE LIMITED</b>, having its principal place of business at “Office no. 304, Laxman Palace, Delhi” and operating under the brand name <b>“CreditPlate”</b>, and You (the “User”). 
          Your use of this platform implies that you have read, understood, and agreed to abide by the following 
          disclaimer and the Terms & Conditions.
        </p>
        <p>
          CreditPlate may, at its sole discretion, amend the Terms & Conditions from time to time. Amendments shall 
          be effective upon the posting of such updated Terms on the Website. Your continued use of the services 
          constitutes your consent to be bound by the amended Terms.
        </p>

        <h2>Eligibility</h2>
        <p>
          To use the Website, you must be at least 21 years old and a resident of India. You represent and warrant 
          that you have the legal capacity to enter into this agreement. Any use of the CreditPlate system by 
          ‘bots’ or other automated tools is strictly prohibited.
        </p>

        <h2>Account Set Up</h2>
        <p>
          To avail of our Services, you must register for a Service Account. You are required to submit accurate 
          information, including your name, address, phone number, and Permanent Account Number (PAN). 
          Failure to maintain up-to-date information may result in the termination of your access to the Services. 
          You are responsible for maintaining the security of your account credentials.
        </p>

        <h2>Service Description</h2>
        <p>
          The Service includes access to the CreditPlate system for creditworthiness assessment and the ability 
          to apply for short-term credit facilities. Approval of a Credit Facility Application is determined 
          by our internal algorithms and risk evaluation parameters. There is no guarantee that an application 
          will be approved for every user.
        </p>

        <p>
          By using our Services, you authorize MARATHON FINLEASE PRIVATE LIMITED to verify your details, check 
          credit references, and obtain credit reports from bureaus to determine your eligibility. 
          If approved, you must execute a formal loan agreement and repay the advance along with all applicable 
          interest and charges on the specified due dates.
        </p>

        <h2>License and Restrictions</h2>
        <p>
          Subject to compliance, CreditPlate grants you a limited, non-exclusive, non-transferable license to 
          access the Website for personal, non-commercial use. 
        </p>
        <p><b>You shall not:</b></p>
        <ul>
          <li>Provide third parties with access to your account.</li>
          <li>Use the services for junk mail, spam, or unauthorized advertising.</li>
          <li>Decompile, reverse engineer, or disassemble any portion of the Website.</li>
          <li>Scrape, index, or data mine the platform for any unauthorized purpose.</li>
          <li>Upload content that is unlawful, defamatory, or infringes on third-party intellectual property.</li>
        </ul>

        <h2>Limited Warranty & Liability</h2>
        <p>
          MARATHON FINLEASE PRIVATE LIMITED shall not be held liable for any indirect, incidental, or 
          consequential damages arising out of your use of the Website. Our liability, if any, shall 
          be limited to the maximum extent permitted by applicable Indian laws. We do not guarantee 
          that the Website will be uninterrupted or error-free at all times.
        </p>

        <h2>Loan Specific Terms</h2>
        <p>
          <b>Annual Percentage Rate (APR):</b> The APR ranges from 120% to 365%, covering the all-inclusive 
          cost of the loan.
          <br />
          <b>Tenure:</b> The repayment period shall be as specified in your loan agreement, typically ranging 
          from 7 to 90 days.
        </p>

        <h2>Arbitration and Governing Law</h2>
        <p>
          This Agreement shall be governed by the laws of India. Any disputes arising under this Agreement 
          shall be subject to the exclusive jurisdiction of the competent courts in <b>Delhi, India</b>.
        </p>

        <h2>Termination</h2>
        <p>
          Either party may terminate this agreement with thirty (30) days' notice. However, termination 
          will not extinguish your obligation to repay any outstanding loans or dues to MARATHON FINLEASE PRIVATE LIMITED.
        </p>

        <h2>Notices & Contact</h2>
        <p>
          All notices to the Company should be sent via email to: <b>info@creditplates.com</b> 
          <br />
          <b>Registered Address:</b> Office no. 304, Laxman Palace, Delhi
        </p>

        <h2>Entire Agreement</h2>
        <p>
          These Terms, along with the Privacy Policy and Loan Agreement, constitute the entire agreement between 
          you and MARATHON FINLEASE PRIVATE LIMITED regarding the use of the platform.
        </p>
      </section>
    </div>
  );
};

export default TermsConditions;